if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0);
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
      });

      if (this.productForm) observer.observe(this.productForm);
      if (this.productInfo) observer.observe(this.productInfo);

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}

/**
 * BF3D product page conversion enhancements.
 * 1. One-click sticky add-to-cart for products without variant choices.
 * 2. Stronger BF3D compatibility check presentation.
 */
(() => {
  const initBF3DProductEnhancements = () => {
    const productSection = document.querySelector('.cc-main-product');
    if (!productSection) return;

    if (!document.getElementById('bf3d-product-enhancements-style')) {
      const style = document.createElement('style');
      style.id = 'bf3d-product-enhancements-style';
      style.textContent = `
        .bf3d-sticky-cart-button {
          background: #63C43C !important;
          border-color: #63C43C !important;
          color: #fff !important;
        }
        .bf3d-sticky-cart-button:hover,
        .bf3d-sticky-cart-button:focus-visible {
          background: #52ad32 !important;
          border-color: #52ad32 !important;
          color: #fff !important;
        }
        .bf3d-compat-heading-wrap {
          display: flex;
          flex-direction: column;
          line-height: 1.25;
        }
        .bf3d-compat-subtitle {
          display: block;
          margin-top: 2px;
          font-size: 11.5px;
          font-weight: 400;
          opacity: .72;
        }
        .bf3d-compat-help {
          margin-top: 12px;
          padding: 10px 12px;
          background: #f7fbf4;
          border-left: 3px solid #63C43C;
          border-radius: 4px;
          font-size: 12.5px;
          line-height: 1.45;
        }
      `;
      document.head.appendChild(style);
    }

    const stickyLink = document.querySelector('.sticky-atc-panel .card__buttons a');
    const mainForm = productSection.querySelector('.js-product-form-main');
    const mainAddButton = mainForm ? mainForm.querySelector('button[name="add"]') : null;
    const productOptions = productSection.querySelector('.product-options');
    const hasVariantChoices = Boolean(productOptions && !productOptions.hidden && productOptions.offsetParent !== null);

    if (stickyLink && mainAddButton && !hasVariantChoices && !mainAddButton.disabled) {
      stickyLink.textContent = 'In den Warenkorb';
      stickyLink.classList.add('bf3d-sticky-cart-button');

      if (!stickyLink.dataset.bf3dDirectCart) {
        stickyLink.dataset.bf3dDirectCart = 'true';
        stickyLink.addEventListener('click', (event) => {
          event.preventDefault();
          const activeAddButton = productSection.querySelector('.js-product-form-main button[name="add"]');
          if (activeAddButton && !activeAddButton.disabled) {
            activeAddButton.click();
          }
        });
      }
    }

    const compatTitle = productSection.querySelector('.bf3d-compat-title');
    if (compatTitle && !compatTitle.closest('.bf3d-compat-heading-wrap')) {
      const wrap = document.createElement('span');
      wrap.className = 'bf3d-compat-heading-wrap';
      compatTitle.parentNode.insertBefore(wrap, compatTitle);
      wrap.appendChild(compatTitle);
      compatTitle.textContent = 'BF3D Kompatibilitäts-Check';

      const subtitle = document.createElement('span');
      subtitle.className = 'bf3d-compat-subtitle';
      subtitle.textContent = 'Passt zu meinem Mähroboter?';
      wrap.appendChild(subtitle);
    }

    const compatContent = productSection.querySelector('.bf3d-compat-content');
    if (compatContent && !compatContent.querySelector('.bf3d-compat-help')) {
      const help = document.createElement('div');
      help.className = 'bf3d-compat-help';
      help.innerHTML = '<strong>Modell nicht dabei?</strong><br>Wir prüfen die Kompatibilität gerne für dich. Nutze dafür einfach die WhatsApp-Beratung auf dieser Seite.';
      compatContent.appendChild(help);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBF3DProductEnhancements, { once: true });
  } else {
    initBF3DProductEnhancements();
  }
})();
